(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2197],{

/***/ 75247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _ErrorPage_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2706);
/* harmony import */ var components_UI_Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92327);
/* harmony import */ var nzk_react_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62058);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);







var ObjectNotFoundError = function ObjectNotFoundError(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_ErrorPage_styles__WEBPACK_IMPORTED_MODULE_1__/* .StyledContainer */ .PQ, {
    color: props.bgColor || '#512B6F',
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_ErrorPage_styles__WEBPACK_IMPORTED_MODULE_1__/* .ContentContainer */ .OO, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_ErrorPage_styles__WEBPACK_IMPORTED_MODULE_1__/* .StyledText */ .qY, {
        children: [props.objectTitle, " not found"]
      }), props.link && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_UI_Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        to: props.link,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(nzk_react_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
          theme: "primary",
          size: "regular",
          children: "Back"
        })
      }), props.action && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(nzk_react_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        theme: "primary",
        size: "regular",
        onClick: props.action,
        children: "Back"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_ErrorPage_styles__WEBPACK_IMPORTED_MODULE_1__/* .WillCharacter */ .NS, {})]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (ObjectNotFoundError);

/***/ }),

/***/ 92327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83058);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var LinkContent = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Link__LinkContent",
  componentId: "sc-1jumwjv-0"
})(["cursor:pointer;"]);

var Link = function Link(props) {
  var replace = props.replace,
      href = props.href,
      to = props.to,
      children = props.children;

  var handleClick = function handleClick(ev) {
    if (replace && href) {
      ev.preventDefault();
      window.location.replace(href);
    }
  };

  if (!to && !href) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
      children: children
    });
  }

  return to ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
    href: to.replace('/edu', ''),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(LinkContent, {
      children: children
    })
  }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("a", _objectSpread(_objectSpread({
    href: href,
    onClick: handleClick
  }, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
      children: children
    })
  }));
};

Link.navigate = function (props) {
  var link = typeof props === 'string' ? props : props.to || props.href;
  var replace = props.replace;

  if (replace) {
    window.location.replace(link);
  } else {
    window.location.assign(link);
  }
};

/* harmony default export */ __webpack_exports__["Z"] = (Link);

/***/ }),

/***/ 54303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var components_Error_ObjectNotFoundError__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75247);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




var NotFoundPage = function NotFoundPage() {
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_Error_ObjectNotFoundError__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
    objectTitle: "Page",
    action: router.back
  });
};

/* harmony default export */ __webpack_exports__["default"] = (NotFoundPage);

/***/ }),

/***/ 49463:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(54303);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(49463); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);